/* THIS FILE IS GENERATED - DO NOT EDIT DIRECTLY */
import React from 'react'

export const ArrowRight = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"M5 12h14"} key={"1ays0h"} />
    <path d={"m12 5 7 7-7 7"} key={"xquz4c"} />
  </svg>
)

export const ArrowUpDown = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"m21 16-4 4-4-4"} key={"f6ql7i"} />
    <path d={"M17 20V4"} key={"1ejh1v"} />
    <path d={"m3 8 4-4 4 4"} key={"11wl7u"} />
    <path d={"M7 4v16"} key={"1glfcx"} />
  </svg>
)

export const Boxes = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"} key={"lc1i9w"} />
    <path d={"m7 16.5-4.74-2.85"} key={"1o9zyk"} />
    <path d={"m7 16.5 5-3"} key={"va8pkn"} />
    <path d={"M7 16.5v5.17"} key={"jnp8gn"} />
    <path d={"M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"} key={"8zsnat"} />
    <path d={"m17 16.5-5-3"} key={"8arw3v"} />
    <path d={"m17 16.5 4.74-2.85"} key={"8rfmw"} />
    <path d={"M17 16.5v5.17"} key={"k6z78m"} />
    <path d={"M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"} key={"1xygjf"} />
    <path d={"M12 8 7.26 5.15"} key={"1vbdud"} />
    <path d={"m12 8 4.74-2.85"} key={"3rx089"} />
    <path d={"M12 13.5V8"} key={"1io7kd"} />
  </svg>
)

export const Building2 = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"M10 12h4"} key={"a56b0p"} />
    <path d={"M10 8h4"} key={"1sr2af"} />
    <path d={"M14 21v-3a2 2 0 0 0-4 0v3"} key={"1rgiei"} />
    <path d={"M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2"} key={"secmi2"} />
    <path d={"M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16"} key={"16ra0t"} />
  </svg>
)

export const ChartNoAxesColumn = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"M5 21v-6"} key={"1hz6c0"} />
    <path d={"M12 21V3"} key={"1lcnhd"} />
    <path d={"M19 21V9"} key={"unv183"} />
  </svg>
)

export const ChevronRight = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"m9 18 6-6-6-6"} key={"mthhwq"} />
  </svg>
)

export const CircleCheck = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <circle cx={"12"} cy={"12"} r={"10"} key={"1mglay"} />
    <path d={"m9 12 2 2 4-4"} key={"dzmm74"} />
  </svg>
)

export const LayoutGrid = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <rect width={"7"} height={"7"} x={"3"} y={"3"} rx={"1"} key={"1g98yp"} />
    <rect width={"7"} height={"7"} x={"14"} y={"3"} rx={"1"} key={"6d4xhi"} />
    <rect width={"7"} height={"7"} x={"14"} y={"14"} rx={"1"} key={"nxv5o0"} />
    <rect width={"7"} height={"7"} x={"3"} y={"14"} rx={"1"} key={"1bb6yr"} />
  </svg>
)

export const LifeBuoy = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <circle cx={"12"} cy={"12"} r={"10"} key={"1mglay"} />
    <path d={"m4.93 4.93 4.24 4.24"} key={"1ymg45"} />
    <path d={"m14.83 9.17 4.24-4.24"} key={"1cb5xl"} />
    <path d={"m14.83 14.83 4.24 4.24"} key={"q42g0n"} />
    <path d={"m9.17 14.83-4.24 4.24"} key={"bqpfvv"} />
    <circle cx={"12"} cy={"12"} r={"4"} key={"4exip2"} />
  </svg>
)

export const LockKeyhole = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <circle cx={"12"} cy={"16"} r={"1"} key={"1au0dj"} />
    <rect x={"3"} y={"10"} width={"18"} height={"12"} rx={"2"} key={"6s8ecr"} />
    <path d={"M7 10V7a5 5 0 0 1 10 0v3"} key={"1pqi11"} />
  </svg>
)

export const Package = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"} key={"1a0edw"} />
    <path d={"M12 22V12"} key={"d0xqtd"} />
    <polyline points={"3.29 7 12 12 20.71 7"} key={"ousv84"} />
    <path d={"m7.5 4.27 9 5.15"} key={"1c824w"} />
  </svg>
)

export const Settings2 = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"M14 17H5"} key={"gfn3mx"} />
    <path d={"M19 7h-9"} key={"6i9tg"} />
    <circle cx={"17"} cy={"17"} r={"3"} key={"18b49y"} />
    <circle cx={"7"} cy={"7"} r={"3"} key={"dfmy0x"} />
  </svg>
)

export const Shield = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"} key={"oel41y"} />
  </svg>
)

export const Sparkles = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"} key={"1s2grr"} />
    <path d={"M20 2v4"} key={"1rf3ol"} />
    <path d={"M22 4h-4"} key={"gwowj6"} />
    <circle cx={"4"} cy={"20"} r={"2"} key={"6kqj1y"} />
  </svg>
)

export const TrendingUp = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"M16 7h6v6"} key={"box55l"} />
    <path d={"m22 7-8.5 8.5-5-5L2 17"} key={"1t1m79"} />
  </svg>
)

export const Users = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"} key={"1yyitq"} />
    <path d={"M16 3.128a4 4 0 0 1 0 7.744"} key={"16gr8j"} />
    <path d={"M22 21v-2a4 4 0 0 0-3-3.87"} key={"kshegd"} />
    <circle cx={"9"} cy={"7"} r={"4"} key={"nufk8"} />
  </svg>
)

export const Wallet = ({ size = 24, strokeWidth = 2, color = 'currentColor', strokeLinecap = 'round', strokeLinejoin = 'round', className, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} className={className} {...props}>
    <path d={"M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"} key={"18etb6"} />
    <path d={"M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"} key={"xoc0q4"} />
  </svg>
)

export const BarChart2 = ChartNoAxesColumn
export const CheckCircle2 = CircleCheck
export default { ArrowRight, ArrowUpDown, Boxes, Building2, ChartNoAxesColumn, ChevronRight, CircleCheck, LayoutGrid, LifeBuoy, LockKeyhole, Package, Settings2, Shield, Sparkles, TrendingUp, Users, Wallet, BarChart2, CheckCircle2 }
